import { ScheduleRouteRepetitionType } from '~globals/types/enums';

import { ScheduleRouteRepetionDescriptionStrategy } from './types';
import { buildBaseText, appendDaysToDescription } from './helpers';

const dailyStrategy: ScheduleRouteRepetionDescriptionStrategy = ({
  repeatInterval,
}) =>
  buildBaseText({
    repeatInterval,
    singular: 'día',
  });

const weeklyStrategy: ScheduleRouteRepetionDescriptionStrategy = ({
  repeatInterval,
  dayLabels,
}) => {
  const baseDescription = buildBaseText({ repeatInterval, singular: 'semana' });

  return appendDaysToDescription({ description: baseDescription, dayLabels });
};

const monthlyStrategy: ScheduleRouteRepetionDescriptionStrategy = ({
  repeatInterval,
}) =>
  buildBaseText({
    repeatInterval,
    singular: 'mes',
    plural: 'meses',
  });

export const repetitionStrategies: Record<
  ScheduleRouteRepetitionType,
  ScheduleRouteRepetionDescriptionStrategy
> = {
  [ScheduleRouteRepetitionType.Daily]: dailyStrategy,
  [ScheduleRouteRepetitionType.Weekly]: weeklyStrategy,
  [ScheduleRouteRepetitionType.Monthly]: monthlyStrategy,
};
